<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>


export default {
  name: "McvApp",
  mounted() {
  }
}
</script>
<style lang="scss"></style>